import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CommonRadioGroupComponent } from './common-radio-group.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';

@NgModule({
  declarations: [CommonRadioGroupComponent],
  imports: [CommonModule, ReactiveFormsModule, FormsModule, IonicModule],
  exports: [CommonRadioGroupComponent],
})
export class CommonRadioGroupModule { }
